import "./style.css"
import { InputDescription, InputValueNumber } from "../Inputs"
import { ButtonEnterValue, ButtonAll, ButttonsEntrada, ButttonsDespesa } from "../Buttons"
import { SelectProhibited } from "../Selects"
import trash from "../../imgs/trash.svg"
import trashWhite from "../../imgs/trash_white.svg"
import { Total } from "../Total"


export const CardSendValue = ({event})=>{

    let list = localStorage.getItem("list")
    list = JSON.parse(list)

    if(list === null){
        list = []
    }

    return(
        <div className="container-send-value flex flex-column gap-medium">
            <form onSubmit={event} className="form-send-value flex flex-column gap-small">
                <div className="cont-responsive-values flex items-start flex-column gap-small">
                    <label className="font-size-4 font-weight-2 font-color-7">Descrição</label>
                    <InputDescription/>
                    <p className="font-size-5 font-weight-2 font-color-6">Ex: Compra de roupas</p>
                </div>
                <div className="cont-responsive-values flex items-start justify-between">
                    <div className="flex items-start flex-column gap-small">
                        <p className="font-size-4 font-weight-2 font-color-7">Valor</p>
                        <div className="container-value-number flex items-center">
                            <InputValueNumber/>
                            <label className="font-size-4 font-weight-2 font-color-7">R$</label>
                        </div>
                    </div>
                    <div className="flex items-start flex-column gap-small">
                        <label className="font-size-4 font-weight-2 font-color-7">Tipo do Valor</label>
                        <SelectProhibited/>
                    </div>
                </div>
                    <ButtonEnterValue type="submit" text="Inserir Valor"/>
            </form>
            {list.length !== 0 ?(<Total/>):("")}
        </div>
    )
}

export const CardFinancialSummary = ({list, eventNav, eventDeleted, nav} )=>{

    const changeTrash = (e)=>{
        e.target.src = trashWhite
    }

    const blackTrash = (e)=>{
        e.target.src = trash
    }

    return(
        list.length === 0 ?(
                <div className="container-financial-summary">
                    <div className="header-send-value flex items-center justify-between">
                        <h2 className="font-size-4 font-weight-1 font-color-7">Resumo financeiro</h2>
                        <div className="flex items-start gap-small">
                            <ButtonAll text="Todos" event={eventNav} nav={nav}/>
                            <ButttonsEntrada text="Entradas" event={eventNav} nav={nav}/>
                            <ButttonsDespesa text="Despesas" event={eventNav} nav={nav}/>
                        </div>
                    </div>
                    <div className="main-send-value flex items-start flex-column gap-small">
                        <p className="font-size-3 font-weight-1 font-color-7">Você ainda não possui nenhum lançamento</p>
                        <div className="container-cards flex items-start gap-medium flex-column">
                            <div className="card-empty flex items-start gap-small flex-column">
                                <div className="empty-1"></div>
                                <div className="empty-2"></div>
                            </div>
                            <div className="card-empty flex items-start gap-small flex-column">
                                <div className="empty-1"></div>
                                <div className="empty-2"></div>
                            </div>
                            <div className="card-empty flex items-start gap-small flex-column">
                                <div className="empty-1"></div>
                                <div className="empty-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ):(
                <div className="container-financial-summary">
                    <div className="header-send-value flex items-center justify-between">
                        <h2 className="font-size-4 font-weight-1 font-color-7">Resumo financeiro</h2>
                        <div className="flex items-start gap-small">
                            <ButtonAll text="Todos" event={eventNav} nav={nav}/>
                            <ButttonsEntrada text="Entradas" event={eventNav} nav={nav}/>
                            <ButttonsDespesa text="Despesas" event={eventNav} nav={nav}/>
                        </div>
                    </div>
                    <div className="main-send-value flex items-start flex-column gap-small">
                        <div className="container-cards flex items-start gap-medium flex-column">
                            {
                                list.map((elem, index)=>{
                                    
                                    let value = parseInt(elem.value)
                                

                                    return(
                                        elem.type === "Entrada" ?(
                                                <div key={index} className="card cardEntrada flex items-start gap-medium flex-column">
                                                    <div className="header-card flex items-start justify-between">
                                                        <h2 className="font-size-4 font-weight-1 font-color-7">{elem.description}</h2>
                                                        <p className="font-size-5 font-weight-2 font-color-6">{value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</p>
                                                        <img data-id={elem.id} alt="trash" src={trash} className="img-trash" onClick={eventDeleted} onMouseOver={changeTrash} onMouseOut={blackTrash}/>
                                                    </div>
                                                    <span className="tag font-size-5 font-weight-2 font-color-7">{elem.type}</span>
                                                </div>
                                            ):(
                                                <div key={index} className="card flex items-start gap-medium flex-column">
                                                    <div className="header-card flex items-start justify-between">
                                                        <h2 className="font-size-4 font-weight-1 font-color-7">{elem.description}</h2>
                                                        <p className="font-size-5 font-weight-2 font-color-6">{value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</p>
                                                        <img data-id={elem.id} alt="trash" src={trash} className="img-trash" onClick={eventDeleted} onMouseOver={changeTrash} onMouseOut={blackTrash}/>
                                                    </div>
                                                    <span className="tag font-size-5 font-weight-2 font-color-7">{elem.type}</span>
                                                </div>
                                            )
                                        )
                                })
                            }
                        </div>
                    </div>
                </div>
               
            )
        )
}

